import { Portal } from "solid-js/web";


export const PortalSearch = params => {
	return (
		<Portal mount={document.getElementById( "search-bar" )}>
			<div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
				<div class="grid flex-1 grid-cols-1" >
					<input onInput={params.onInput} type="search" placeholder={params.placeholder} aria-label={params.placeholder} class="col-start-1 row-start-1 block size-full bg-white pl-8 text-base text-gray-900 outline-hidden placeholder:text-gray-400 sm:text-sm/6" placeholder="Filter" />
					<svg class="pointer-events-none col-start-1 row-start-1 size-5 self-center text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
						<path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z" clip-rule="evenodd" />
					</svg>
				</div>
			</div>
		</Portal> )
}

/*

			<Portal mount={document.getElementById( "search-bar" )}>
				<div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
					<div class="grid flex-1 grid-cols-1" >
						<input type="search" aria-label="Filter" class="col-start-1 row-start-1 block size-full bg-white pl-8 text-base text-gray-900 outline-hidden placeholder:text-gray-400 sm:text-sm/6" placeholder="Filter" onInput={e => setFilter( e.target.value.toLowerCase() )} />
						<svg class="pointer-events-none col-start-1 row-start-1 size-5 self-center text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
							<path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z" clip-rule="evenodd" />
						</svg>
					</div>
				</div>
			</Portal>
*/